import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../src/firebase.js';
import { getCurrentUser } from '../data/auth.js';

export async function loadCreatorStripeProfile(uid) {
    if (!uid) {
        return {
            stripeAccountId: null,
            stripeVerified: false,
            stripeChargesEnabled: false,
            stripePayoutsEnabled: false,
        };
    }
    try {
        const snap = await getDoc(doc(db, 'users', uid));
        const d = snap.data() || {};
        return {
            stripeAccountId: d.stripeAccountId || null,
            stripeVerified: !!d.stripeVerified,
            stripeChargesEnabled: !!d.stripeChargesEnabled,
            stripePayoutsEnabled: !!d.stripePayoutsEnabled,
            stripeDetailsSubmitted: !!d.stripeDetailsSubmitted,
        };
    } catch {
        return { stripeAccountId: null, stripeVerified: false };
    }
}

export async function saveCreatorStripeLocal(uid, patch) {
    if (!uid) return;
    try {
        await setDoc(doc(db, 'users', uid), {
            ...patch,
            stripeUpdatedAt: new Date().toISOString(),
        }, { merge: true });
    } catch (err) {
        console.warn('[fundStripe] could not save user stripe profile', err);
    }
}

export async function startStripeConnectOnboarding() {
    const user = getCurrentUser();
    if (!user?.uid || !user?.email) {
        throw new Error('Sign in to connect Stripe for payouts.');
    }

    const profile = await loadCreatorStripeProfile(user.uid);
    const res = await fetch('/api/stripe-connect', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            uid: user.uid,
            email: user.email,
            stripeAccountId: profile.stripeAccountId,
        }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || 'Could not start Stripe Connect');

    await saveCreatorStripeLocal(user.uid, {
        stripeAccountId: data.stripeAccountId,
        stripeVerified: data.stripeVerified,
        stripeChargesEnabled: data.chargesEnabled,
        stripePayoutsEnabled: data.payoutsEnabled,
    });

    if (data.url) window.location.href = data.url;
    return data;
}

export async function refreshStripeConnectStatus() {
    const user = getCurrentUser();
    if (!user?.uid) return null;

    const profile = await loadCreatorStripeProfile(user.uid);
    if (!profile.stripeAccountId) return profile;

    const res = await fetch('/api/stripe-connect/status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            uid: user.uid,
            stripeAccountId: profile.stripeAccountId,
        }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return profile;

    await saveCreatorStripeLocal(user.uid, {
        stripeAccountId: data.stripeAccountId,
        stripeVerified: data.stripeVerified,
        stripeChargesEnabled: data.chargesEnabled,
        stripePayoutsEnabled: data.payoutsEnabled,
        stripeDetailsSubmitted: data.detailsSubmitted,
    });

    return {
        stripeAccountId: data.stripeAccountId,
        stripeVerified: data.stripeVerified,
        stripeChargesEnabled: data.chargesEnabled,
        stripePayoutsEnabled: data.payoutsEnabled,
        stripeDetailsSubmitted: data.detailsSubmitted,
    };
}

export function isCampaignFinanciallyLocked(campaign) {
    return !!(campaign?.financialLocked && campaign?.stripeVerified);
}
